module.exports = __webpack_public_path__ + "static/media/correos.df826742.svg";